import Vue from 'vue';
import Vuex from 'vuex';
// import compose from './compose';
// import contextmenu from './contextmenu';
// import copy from './copy';
// import event from './event';
// import layer from './layer';
// import snapshot from './snapshot';
// import lock from './lock';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    allowShowAside: false,
    editableTabObj: {},
    loginUserObj: {},
    pageName:"",
    orderBid:''

  },
  mutations: {
    getPageName(state,name){
      state.pageName = name
    },
    loginUserMsg(state, obj) {
      Object.assign(state.loginUserObj, obj);
    },
    setOrderString(state,id){
      state.orderBid = id
    },
    allowAside(state) {
      state.allowShowAside = !state.allowShowAside;
    },
    getWhiteList(state, item) {
      //数组对象通过id查询
      let buttonList = [];
      if (item.operationList) {
        item.operationList.forEach(val => {
          buttonList.push(val.operationDisplayName);
        });
        item.operationList = buttonList;
      }

      state.editableTabObj = item;
      // Vue.set(state, 'editableTabObj', item);
    },
    //获取焦点之后获取对象
    setCurComponent(state, { component, index }) {
      state.curComponent = component;
      state.curComponentIndex = index;
    },
    //修改样式之后
    setShapeStyle({ curComponent }, { top, left, width, height, rotate }) {
      if (top) {
        curComponent.style.top = top;
      }
      if (left) {
        curComponent.style.left = left;
      }
      if (width) {
        curComponent.style.width = width;
      }
      if (height) {
        curComponent.style.height = height;
      }
      if (rotate) {
        curComponent.style.rotate = rotate;
      }
    },
    //拖动修改数值
    setShapeSingleStyle({ curComponent }, { key, value }) {
      curComponent.style[key] = value;
    },

    setComponentData(state, componentData = []) {
      Vue.set(state, 'componentData', componentData);
    },

    addComponent(state, { component, index }) {
      console.log(state);
      if (index !== undefined) {
        state.componentData.splice(index, 0, component);
      } else {
        state.componentData.push(component);
      }
    },
  },
  actions: {},
  getters: {
    doneTodos: state => {
      //通过方法访问
      return state.allowShowAside;
    },
    setOrderBid: state => {
      console.log(123)
      //通过方法访问
      return state.orderBid;
    },
    setTabsList: state => {
      //通过方法访问
      return state.editableTabObj;
    },
    userLoginObj: state => {
      //通过方法访问
      return state.loginUserObj;
    },
    pageNameSet: state => {
      //通过方法访问
      return state.pageName;
    },
  }
});
